import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useDeleteProduct(): UseMutationResult<
  AxiosResponse<null>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const deleteProduct = (productId: string): Promise<AxiosResponse<null>> => {
    return client.delete(`products/${productId}/`);
  };

  return useMutation(deleteProduct, {
    onSuccess: () => {
      queryClient.removeQueries(['products']);
    },
  });
}
